import { render, staticRenderFns } from "./FakeDoorFormStepTwo.vue?vue&type=template&id=498da004&scoped=true"
import script from "./FakeDoorFormStepTwo.vue?vue&type=script&lang=js"
export * from "./FakeDoorFormStepTwo.vue?vue&type=script&lang=js"
import style0 from "./FakeDoorFormStepTwo.vue?vue&type=style&index=0&id=498da004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498da004",
  null
  
)

export default component.exports